import { languageCultureMap } from './languageCultureMap';

const normalizeLanguageValue = (value: string | null | undefined) =>
  value?.trim()?.toLocaleLowerCase();

export const canonicalLanguage = (value: string | null | undefined) =>
  normalizeLanguageValue(value)?.split(/[-_]/, 1)[0] ?? '';

export function resolveSupportedLanguage(
  value: string | null | undefined,
  fallbackLanguage: string
): string {
  const normalized = normalizeLanguageValue(value);

  if (!normalized) return fallbackLanguage;

  const mappedLanguage = Object.values(languageCultureMap).find(
    (culture) => culture.toLowerCase() === normalized
  );

  return mappedLanguage ?? fallbackLanguage;
}

export type TranslationResourceMap<TTranslation> = Record<string, { translation: TTranslation }>;

export function createTranslationResources<const TResources extends Record<string, unknown>>(
  resources: TResources
): { [TLanguage in keyof TResources]: { translation: TResources[TLanguage] } } {
  return Object.fromEntries(
    Object.entries(resources).map(([language, translation]) => [language, { translation }])
  ) as { [TLanguage in keyof TResources]: { translation: TResources[TLanguage] } };
}
